import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item-container" }
const _hoisted_2 = { class: "info-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusTag = _resolveComponent("StatusTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(new Date(_ctx.equipementIntervention.horodatageAppelClient).toLocaleDateString().replaceAll('-', ' / ')), 1),
      _createElementVNode("p", null, _toDisplayString(`${_ctx.$t("equipement.intervention.author")} ${_ctx.equipementIntervention.demandeur}`), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.equipementIntervention.libelle), 1)
    ]),
    _createVNode(_component_StatusTag, {
      status: _ctx.getTraduction(_ctx.equipementIntervention.etatDemande)
    }, null, 8, ["status"])
  ]))
}